/**
 * GTM Initialization Script
 * Uses window.gtmConfig for configuration
 * @typedef {Object} GTMConfig
 * @property {boolean} enabled - GTM enabled status
 * @property {string} gtmId - GTM container ID
 * @property {boolean} bannerTracking - Banner tracking enabled
 * @property {boolean} addToCart - Add to cart tracking enabled
 * @property {boolean} purchaseEvent - Purchase event tracking enabled
 * @property {boolean} bidEvent - BID event tracking enabled
 */

// Check if GTM is enabled
// @ts-ignore - GTM config is injected by Liquid template
if (!window.gtmConfig || !window.gtmConfig.enabled) {
  console.log("GTM is disabled in theme settings");
} else {
  // Initialize dataLayer
  // @ts-ignore - dataLayer is GTM global variable
  /**
   * SPA Page View Tracking (Horizon)
   * Tracks page type for SPA navigation
   */
  function trigger_user_interacton_event() {
    document.removeEventListener("pointermove", trigger_user_interacton_event);
    document.removeEventListener("pointerdown", trigger_user_interacton_event);
    document.removeEventListener("scroll", trigger_user_interacton_event);
    document.removeEventListener("keydown", trigger_user_interacton_event);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "user_interaction"
    });
  }

  function debug_state_handled() {
    let currenturl0 = document.location.href, currenturl = new URL(currenturl0), currentdebugstate = currenturl.searchParams.get("gtm_dvab_debug");
    if (currentdebugstate == 'true') {
      try {
        console.log(currentdebugstate);
        localStorage.setItem("gtm_dvab_debug", currentdebugstate);
      }
      catch (t) { console.log(t) }
    }
    else { };
  };


  function savessshusmc() {
    let referrer0 = document.referrer, currenturl0 = document.location, lsv = JSON.parse(localStorage.getItem("sshusmc")) || {};
    let currentlocalstorageusrc0 = null !== lsv ? lsv.usrc : null, currentlocalstorageuexp0 = null !== lsv ? lsv.epoch : null, onedayinms = 864e5, now0 = Date.now();
    let localstorageexpired = null !== currentlocalstorageuexp0 && now0 > currentlocalstorageuexp0 + onedayinms;
    console.log("localstorageexpired :" + localstorageexpired);
    let fsource = "", fmedium = "", fcampaign = "", currenturl = new URL(currenturl0);
    let currentsource = currenturl.searchParams.get("utm_source"), referrer = "" !== referrer0 ? new URL(referrer0) : "direct", referrerorigin = "direct" === referrer ? "direct" : referrer.origin, currenturlorigin = currenturl.origin, innernavigation = referrerorigin == currenturlorigin;
    function setsshusmc(r, e, n) {
      var u = { usrc: r, umed: e, ucmp: n, epoch: now0 };
      var c = JSON.stringify(u);
      try {
        localStorage.setItem("sshusmc", c), console.log(c)
      }
      catch (r) {
        console.log(r)
      }
    }
    function returnutms() {
      fsource = currentsource || "notfound", fmedium = currenturl.searchParams.get("utm_medium") ? currenturl.searchParams.get("utm_medium") : "notfound", fcampaign = currenturl.searchParams.get("utm_campaign") ? currenturl.searchParams.get("utm_campaign") : "notfound";
      console.log("return utms executed " + fsource + fmedium + fcampaign), setsshusmc(fsource, fmedium, fcampaign)
    }
    function returnreferrer() {
      null !== currentsource ? (console.log("returnreferrer utms found called returnutms func"), returnutms()) : (fsource = referrerorigin || "notfound", fmedium = "referrer", fcampaign = "referrer", console.log("returnreferrer executed " + fsource + fmedium + fcampaign), setsshusmc(fsource, fmedium, fcampaign))
    }
    function returndirect() {
      !0 === innernavigation && null !== currentsource && "direct" === currentlocalstorageusrc0 ? (console.log("returndirect case1 returnign utms"), returnutms()) : null == localstorageexpired && null == currentlocalstorageusrc0 || !1 === localstorageexpired && null == currentlocalstorageusrc0 ? (fsource = "direct", fmedium = "direct", fcampaign = "direct", console.log("return direct executed " + fsource + fmedium + fcampaign), setsshusmc(fsource, fmedium, fcampaign)) : console.log("direct edge case")
    } console.log("innernavigation :" + innernavigation);
    try {
      !0 === innernavigation && null == currentsource ? console.log("inner navigation took place hence no action") : 0 == innernavigation && "direct" !== referrer ? returnreferrer() : !1 === innernavigation && null !== currentsource ? returnutms() : returndirect()
    }
    catch (r) {
      console.error("Error parsing current URL for UTMs:", r)
    }
  };



  function firePageType(methodoftrigger) {
    debug_state_handled();
    window.dataLayer = window.dataLayer || [];
    const path = window.location.pathname;
    const href = window.location.href;
    const sshusmc = JSON.parse(localStorage.getItem('sshusmc')) || {};
    const debugstatus = JSON.parse(localStorage.getItem('gtm_dvab_debug')) || false;
    const pagetitle = window.document.title;
    const customerobject = gtmConfig.customerobject;
    function pushtodlv(payload) {
      console.log('dvab , debug state handled ', debugstatus)
      savessshusmc();
      console.log('sshusmc above and pageview below');
      dataLayer.push({
        event: 'shopifypageview', ecomm_pagetype: payload, sshusmc: sshusmc, methodofpush: methodoftrigger, page_loc: href, page_path: path, page_title: pagetitle, debugstatus: debugstatus, customerobject: customerobject
      });
    };



    if (path === "/") {
      // @ts-ignore - dataLayer is GTM global variable
      pushtodlv('home');
    }

    else if (path.includes("/collections/")) {
      // @ts-ignore - dataLayer is GTM global variable
      pushtodlv('category');
    }

    else if (path.includes("/products/")) {
      // @ts-ignore - dataLayer is GTM global variable
      pushtodlv('product');
    }

    else if (path.includes("/cart")) {
      // @ts-ignore - dataLayer is GTM global variable
      pushtodlv('cart');
    }
    else {
      pushtodlv(window.gtmConfig.pageType);
    }
  };


  /**
   * Horizon SPA navigation listeners
   * Track page type changes during SPA navigation
   */
  document.addEventListener("shopify:section:load", () => firePageType('sectionload'));
  document.addEventListener('DOMContentLoaded', () => firePageType('DOMContentLoaded'));
  window.addEventListener("popstate", () => firePageType('popstate'));
  document.addEventListener("pointermove", trigger_user_interacton_event);
  document.addEventListener("pointerdown", trigger_user_interacton_event);
  document.addEventListener("scroll", trigger_user_interacton_event);
  document.addEventListener("keydown", trigger_user_interacton_event);
  
}
